import { useListBoxSection } from '@react-aria/listbox'
import { useSeparator } from '@react-aria/separator'
import Styles from '../ListBox.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { layoutInfoToStyle, useVirtualizerItem } from '@react-aria/virtualizer'
import { useObjectRef } from '@react-aria/utils'

export const Section = ({ children, section, state, layoutInfo, headerLayoutInfo, virtualizer }: any) => {
  let { headingProps, groupProps } = useListBoxSection({
    heading: section.rendered,
    'aria-label': section['aria-label'],
  })

  const headerRef = useObjectRef<HTMLDivElement>()
  useVirtualizerItem({
    layoutInfo: headerLayoutInfo,
    virtualizer,
    ref: headerRef,
  })

  let { separatorProps } = useSeparator({
    elementType: 'div',
  })

  return (
    <>
      <div role="presentation" ref={headerRef} style={layoutInfoToStyle(headerLayoutInfo, 'ltr')}>
        {section.key !== state.collection.getFirstKey() && <div {...separatorProps} className={Styles.separator} />}
        {section.rendered && (
          <span className={Styles.sectionHeading}>
            <Text variant="label" {...headingProps}>
              {section.rendered}
            </Text>
          </span>
        )}
      </div>
      <ul {...groupProps} className={Styles.root} style={layoutInfoToStyle(layoutInfo, 'ltr')}>
        {children}
      </ul>
    </>
  )
}
